var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { "no-padding": "" } }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Flags", search: "flags" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "add" },
              on: {
                click: function ($event) {
                  return _vm.clickAdd()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v("\n      " + _vm._s(_vm.$t("Button.Add_Flag")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.tenantFlagsList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.FlagCode) +
                                "\n            "
                            ),
                            !props.item.ShowValues
                              ? _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "delete" } },
                                  [_vm._v("priority_high")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.Description)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.ShowValues ? "Yes" : "No")),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "warning",
                                      depressed: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickEdit(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-1" }, [
                                      _vm._v("edit"),
                                    ]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("Button.Edit")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "", color: "error" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickDelete(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-1" }, [
                                      _vm._v("delete_forever"),
                                    ]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("Button.Delete")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-subheader",
        [
          _c("v-icon", { attrs: { small: "", color: "delete" } }, [
            _vm._v("priority_high"),
          ]),
          _vm._v(
            "Results with this flag are hidden in reports, graphs, and\n    queries.\n  "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showAddDialog,
            callback: function ($$v) {
              _vm.showAddDialog = $$v
            },
            expression: "showAddDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("FlagsManage.addTitleMsg"))),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "addForm",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.addForm,
                    callback: function ($$v) {
                      _vm.addForm = $$v
                    },
                    expression: "addForm",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "FlagCode" },
                                model: {
                                  value: _vm.flagData.FlagCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.flagData, "FlagCode", $$v)
                                  },
                                  expression: "flagData.FlagCode",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Description" },
                                model: {
                                  value: _vm.flagData.Description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.flagData, "Description", $$v)
                                  },
                                  expression: "flagData.Description",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Show Flagged Values" },
                                model: {
                                  value: _vm.flagData.ShowValues,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.flagData, "ShowValues", $$v)
                                  },
                                  expression: "flagData.ShowValues",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-0" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade" } },
                        [
                          !_vm.flagData.ShowValues
                            ? _c(
                                "v-subheader",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "delete" } },
                                    [_vm._v("priority_high")]
                                  ),
                                  _vm._v(
                                    "Results with this flag are hidden in reports, graphs,\n              and queries.\n            "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.submitAdd()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Create")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { outline: "", color: "secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showUpdateDialog,
            callback: function ($$v) {
              _vm.showUpdateDialog = $$v
            },
            expression: "showUpdateDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("FlagsManage.updateTitleMsg"))),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "updateForm",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.updateForm,
                    callback: function ($$v) {
                      _vm.updateForm = $$v
                    },
                    expression: "updateForm",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "FlagCode" },
                                model: {
                                  value: _vm.updateData.FlagCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.updateData, "FlagCode", $$v)
                                  },
                                  expression: "updateData.FlagCode",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Description" },
                                model: {
                                  value: _vm.updateData.Description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.updateData, "Description", $$v)
                                  },
                                  expression: "updateData.Description",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Show Flagged Values" },
                                model: {
                                  value: _vm.updateData.ShowValues,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.updateData, "ShowValues", $$v)
                                  },
                                  expression: "updateData.ShowValues",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pt-0" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade" } },
                        [
                          !_vm.updateData.ShowValues
                            ? _c(
                                "v-subheader",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "delete" } },
                                    [_vm._v("priority_high")]
                                  ),
                                  _vm._v(
                                    "Results with this flag are hidden in reports, graphs,\n              and queries.\n            "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.submitUpdate()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { outline: "", color: "secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.comfirmDialog,
            callback: function ($$v) {
              _vm.comfirmDialog = $$v
            },
            expression: "comfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("FlagsManage.confirmTitleMsg"))),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("FlagsManage.confirmTextMsg"))),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmDelete()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("Button.Confirm")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.comfirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }